/**
*  料金シミュレーター
*
*  DOM elements Variables
*
*  @since 2019.9.13
*  @use jQuery
*/



// form の id
const currentForm = {
  entrance          : '#entrance',    // 入所
  entranceSub       : '#entranceSub', // 入所（認知棟）
  shortStay         : '#short',           // 短期入所
  shortStaySub      : '#shortSub',        // 短期入所（認知棟）
  rehaDaycare       : '#daycare',         // 通所リハビリテーション
  rehaDaycareKaigo  : '#daycareKaigo',    // 介護予防通所リハビリテーション
  rehaVisit         : '#visit'            // 訪問リハビリテーション
}



// 計算するボタン の id
const calcBtn = {
  entrance          : '#entranceCalcBtn',      // 入所
  entranceSub       : '#entranceSubCalcBtn',   // 入所（認知棟）
  shortStay         : '#shortCalcBtn',         // 短期入所
  shortStaySub      : '#shortSubCalcBtn',      // 短期入所（認知棟）
  rehaDaycare       : '#daycareCalcBtn',       // 通所リハビリテーション
  rehaDaycareKaigo  : '#daycareKaigoCalcBtn',  // 介護予防通所リハビリテーション
  rehaVisit         : '#visitCalcBtn'          // 訪問リハビリテーション
}



// 計算結果を表示する要素 の id
const resultElm = {
  entrance          : '#entranceResult',      // 入所
  entranceSub       : '#entranceSubResult',   // 入所（認知棟）
  shortStay         : '#shortResult',         // 短期入所
  shortStayDays     : '#selectNumsDays',      // 短期入所（利用日数の表示用）
  shortStaySub      : '#shortSubResult',      // 短期入所（認知棟）
  shortStaySubDays  : '#selectNumsSubDays',   // 短期入所（認知棟）（利用日数の表示用）
  rehaDaycare       : '#daycareResult',       // 通所リハビリテーション
  rehaDaycareKaigo  : '#daycareKaigoResult',  // 介護予防通所リハビリテーション
  rehaVisit         : '#visitResult'          // 訪問リハビリテーション
}



// error を表示するオブジェクト
const errorElm = {
  message : '<div class="error_message">選択してください</div>',
  class   : '_error'
}



// 数値を3桁カンマ区切りの文字列に変更する
const numberWithComma = new Intl.NumberFormat();



// 各 select 要素を操作したときのアクション
$(document).on('change', 'select', function(){
  const currentForm = $(this).parents('form').attr('id');
  const name        = $(this).attr('name');
  //console.log(name);
  // 選択されたときエラー表示を消す
  if( $(this).val() ){ $( '#' + currentForm + ' #' + name + '_error' ).empty(); }
});



/** function */
const selectCheck = function( $_form, $_value )
{
  let selectVal = {};
  let flag = true;

  $.each( $_value, function( i, elem ) {
    // 選択されているかチェック
    if( !elem.value ){
      // 選択されていない項目に error 表示
      $( $_form + ' #' + this.name + errorElm.class ).html( errorElm.message );
      flag = false;
    } else {
      // 選択された項目の value 値を配列に収める
      selectVal[elem.name] = elem.value;
    }
  });

  if( flag === true ){ return selectVal; } else { return false; }

}



const outputOption = function()
{
  for ( let i = 2; i <= 31; i++ ) {
    $(this).html('<option value="' + i + '">' + i + '日</option>');
  }
}
